export const CytoSteps = ['60', '75', '90', '105'] as const
export type TCytoStep = typeof CytoSteps[number]

export const CytoFields = [ 'LAIL6', 'LAIL8', 'LAIL10', 'LAIL1B' ] as const
export type TCytoField = typeof CytoFields[number]

export type TCytoPoint = {
    [k in TCytoField]?: number
}

export type TMemCytoData = {
    [k in TCytoStep]: TCytoPoint
}

